import { useMemo } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { useExtensionGovernanceUsersQuery } from "app/pages/sales-intelligence/modules/extension-management/query/queries/useExtensionGovernanceUsersQuery";
import { computeAdoptionStats } from "app/pages/sales-intelligence/modules/extension-management/services/computeAdoptionStats";
import { GovernanceUsersTable } from "app/pages/sales-intelligence/pages/management/components/GovernanceUsersTable/GovernanceUsersTable";

import { ExtensionAdoptionStatsCards } from "../../components/ExtensionAdoptionStatsCards/ExtensionAdoptionStatsCards";
import { SettingsSectionBlock } from "../../components/SettingsSectionBlock/SettingsSectionBlock";

export const InsightsAndAdoptionTab = () => {
    const { data: governanceUsersData } = useExtensionGovernanceUsersQuery();
    const adoptionStats = useMemo(
        () => (governanceUsersData ? computeAdoptionStats(governanceUsersData.items) : undefined),
        [governanceUsersData],
    );

    return (
        <Stack
            gap="20px"
            margin="20px 0 40px"
        >
            {adoptionStats ? <ExtensionAdoptionStatsCards stats={adoptionStats} /> : null}
            <SettingsSectionBlock
                dataAutomation="sales-intelligence-extension-governance-users-table-section"
                padding="24px 0"
            >
                <GovernanceUsersTable />
            </SettingsSectionBlock>
        </Stack>
    );
};
